export const BUMI = [
  { text: 'Bumiputera', value: 'Bumiputera' },
  { text: 'Non-Bumiputera', value: 'Non-Bumiputera' },
  { text: 'Not Applicable', value: 'Not Applicable' },
];
export default BUMI;



// WEBPACK FOOTER //
// ./src/constants/bumi.js